import { render, staticRenderFns } from "./VulnerabilityList.vue?vue&type=template&id=4f4b1a2a&scoped=true"
import script from "./VulnerabilityList.vue?vue&type=script&lang=js"
export * from "./VulnerabilityList.vue?vue&type=script&lang=js"
import style0 from "./VulnerabilityList.vue?vue&type=style&index=0&id=4f4b1a2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4b1a2a",
  null
  
)

export default component.exports